import { Injectable } from '@angular/core';
import { IDBPDatabase, openDB } from 'idb';

@Injectable({
  providedIn: 'root'
})
export class DbContextService {
  private dbPromise?: Promise<IDBPDatabase<any>>;
  private dbInstace?: IDBPDatabase<any>;
  private db: any;
  dbName = 'IFSOBSWS-db';
  dbNameSec = 'IFSOBSWS-dbSec';
  dbTableName = 'failedRequests';
  dbVersion = 10;
  dbSecVersion = 2;
  constructor() {
    if (!('indexedDB' in window)) {
      throw new Error('This browser doesn\'t support IndexedDB');
    }
  }

  getId() {
    // creating a genuine GUID in javascript is kind of a bizarre thing,
    // I'm using a simple timestamp for this demo.
    return new Date().getTime();
  }
  deleteIndDB() {
    let indexDB = indexedDB.deleteDatabase(this.dbName);
    indexDB.onsuccess = function (event) {

    }
    indexDB.onerror = function (event) {

    }
  }

  openSecurityDatabase() {
    return openDB(this.dbNameSec, this.dbSecVersion, {
      upgrade(upgradeDb) {
        console.log('upgrade');
        if (!upgradeDb.objectStoreNames.contains('OWS_tblTrustedMachine')) {
          upgradeDb.createObjectStore('OWS_tblTrustedMachine', { keyPath: 'userName' });
        }
        if (!upgradeDb.objectStoreNames.contains('OWS_UserInfo')) {
          upgradeDb.createObjectStore('OWS_UserInfo', { keyPath: 'userID' });
        }
        if (!upgradeDb.objectStoreNames.contains('OWS_IsAuthenticated')) {
          upgradeDb.createObjectStore('OWS_IsAuthenticated', { keyPath: 'userName' });
        }

      },
      blocked() {
        console.log('blocked');
      },
      blocking() {
        console.log('blocking');
      },
      terminated() {
        console.log('terminated');
      }
    });
  }


  async openDatabase() {
    if (!this.dbPromise) {
      this.dbPromise = openDB(this.dbName, this.dbVersion, {
        upgrade(upgradeDb) {
          console.log('upgrade');
          // switch (upgradeDb.version) {
          //   case 1:
          if (!upgradeDb.objectStoreNames.contains('failedRequests')) {
            upgradeDb.createObjectStore('failedRequests', { keyPath: 'clientId' },);
          }

          if (!upgradeDb.objectStoreNames.contains('OWS_tblOrderHeaderLastSeq')) {
            upgradeDb.createObjectStore('OWS_tblOrderHeaderLastSeq', { keyPath: 'ID' });
          }
          if (!upgradeDb.objectStoreNames.contains('OWS_tblOrderList')) {
            upgradeDb.createObjectStore('OWS_tblOrderList', { keyPath: 'orderListID' });
          }
          if (!upgradeDb.objectStoreNames.contains('OWS_tblOrderDetail')) {
            upgradeDb.createObjectStore('OWS_tblOrderDetail', { keyPath: 'orderID' });
          }
          if (!upgradeDb.objectStoreNames.contains('OWS_tblShipBudgetInfo')) {
            upgradeDb.createObjectStore('OWS_tblShipBudgetInfo', { keyPath: 'shipBudgetID' });
          }
          if (!upgradeDb.objectStoreNames.contains('OWS_tblShipOrderBudget')) {
            upgradeDb.createObjectStore('OWS_tblShipOrderBudget', { keyPath: 'shipOrderBudgetID' });
          }
          if (!upgradeDb.objectStoreNames.contains('OWS_tblOrderWeightByCategory')) {
            upgradeDb.createObjectStore('OWS_tblOrderWeightByCategory', { keyPath: 'orderWeightByCategoryID' });
          }

          if (!upgradeDb.objectStoreNames.contains('OWS_tblOrderInfoHeader')) {
            upgradeDb.createObjectStore('OWS_tblOrderInfoHeader', { keyPath: 'orderInfoHeaderID' });
          }

          if (!upgradeDb.objectStoreNames.contains('OWS_tblOrderOverviewSubmitted')) {
            upgradeDb.createObjectStore('OWS_tblOrderOverviewSubmitted', { keyPath: 'orderInfoHeaderID' });
          }

          if (!upgradeDb.objectStoreNames.contains('OWS_tblOrderOverviewDelivered')) {
            upgradeDb.createObjectStore('OWS_tblOrderOverviewDelivered', { keyPath: 'orderInfoHeaderID' });
          }

          if (!upgradeDb.objectStoreNames.contains('OWS_tblOrderOverviewOpen')) {
            upgradeDb.createObjectStore('OWS_tblOrderOverviewOpen', { keyPath: 'orderInfoHeaderID' });
          }

          if (!upgradeDb.objectStoreNames.contains('OWS_tblShipCrew')) {
            upgradeDb.createObjectStore('OWS_tblShipCrew', { keyPath: 'shipCrewID' });
          }

          if (!upgradeDb.objectStoreNames.contains('OWS_tblOrderListItem')) {
            upgradeDb.createObjectStore('OWS_tblOrderListItem', { keyPath: 'orderListItemId' });
          }

          if (!upgradeDb.objectStoreNames.contains('OWS_tblNotification')) {
            upgradeDb.createObjectStore('OWS_tblNotification', { keyPath: 'notificationID' });
          }

          if (!upgradeDb.objectStoreNames.contains('OWS_tblCrewType')) {
            upgradeDb.createObjectStore('OWS_tblCrewType', { keyPath: 'crewSubTypeID' });
          }

          if (!upgradeDb.objectStoreNames.contains('OWS_tblExchangeRate')) {
            upgradeDb.createObjectStore('OWS_tblExchangeRate', { keyPath: 'exchangeRateID' });
          }
          if (!upgradeDb.objectStoreNames.contains('IFSOBSWS_Queue')) {
            upgradeDb.createObjectStore('IFSOBSWS_Queue', { keyPath: 'queueID' });
          }

          if (!upgradeDb.objectStoreNames.contains('OWS_tblClaims')) {
            upgradeDb.createObjectStore('OWS_tblClaims', { keyPath: 'claimID' });
          }

          if (!upgradeDb.objectStoreNames.contains('OWS_tblClaimsActive')) {
            upgradeDb.createObjectStore('OWS_tblClaimsActive', { keyPath: 'claimID' });
          }

          if (!upgradeDb.objectStoreNames.contains('OWS_tblClaimsSolved')) {
            upgradeDb.createObjectStore('OWS_tblClaimsSolved', { keyPath: 'claimID' });
          }

          if (!upgradeDb.objectStoreNames.contains('OWS_tblClaimsDocument')) {
            upgradeDb.createObjectStore('OWS_tblClaimsDocument', { keyPath: 'claimID' });
          }

          if (!upgradeDb.objectStoreNames.contains('OWS_tblDMSummary')) {
            upgradeDb.createObjectStore('OWS_tblDMSummary', { keyPath: 'dailyMealsAndFeesId' });
          }
          if (!upgradeDb.objectStoreNames.contains('OWS_tblDMOverviewSubmitted')) {
            upgradeDb.createObjectStore('OWS_tblDMOverviewSubmitted', { keyPath: 'dailyMealsAndFeesID' });
          }
          if (!upgradeDb.objectStoreNames.contains('OWS_tblDMOverviewApproved')) {
            upgradeDb.createObjectStore('OWS_tblDMOverviewApproved', { keyPath: 'dailyMealsAndFeesID' });
          }
          if (!upgradeDb.objectStoreNames.contains('OWS_tblDailyMealsAndFees')) {
            upgradeDb.createObjectStore('OWS_tblDailyMealsAndFees', { keyPath: 'dailyMealsAndFeesID' });
          }
          if (!upgradeDb.objectStoreNames.contains('OWS_tblDailyMealsAndFeesDetails')) {
            upgradeDb.createObjectStore('OWS_tblDailyMealsAndFeesDetails', { keyPath: 'dailyMealsAndFeesDetailsID' });
          }
          if (!upgradeDb.objectStoreNames.contains('OWS_tblMeals')) {
            upgradeDb.createObjectStore('OWS_tblMeals', { keyPath: 'mealID' });
          }
          if (!upgradeDb.objectStoreNames.contains('OWS_tblDMCrewTypes')) {
            upgradeDb.createObjectStore('OWS_tblDMCrewTypes', { keyPath: 'crewTypeID' });
          }
          if (!upgradeDb.objectStoreNames.contains('OWS_tblDMCrewSubTypes')) {
            upgradeDb.createObjectStore('OWS_tblDMCrewSubTypes', { keyPath: 'crewSubTypeID' });
          }
          if (!upgradeDb.objectStoreNames.contains('OWS_tblOffice')) {
            upgradeDb.createObjectStore('OWS_tblOffice', { keyPath: 'officeID' });
          }
          if (!upgradeDb.objectStoreNames.contains('OWS_tblContact')) {
            upgradeDb.createObjectStore('OWS_tblContact', { keyPath: 'shipOrderHandlerID' });
          }
          if (!upgradeDb.objectStoreNames.contains('OWS_tblSupplierSurvey')) {
            upgradeDb.createObjectStore('OWS_tblSupplierSurvey', { keyPath: 'orderInfoHeaderID' });
          }
          if (!upgradeDb.objectStoreNames.contains('OWS_tblShips')) {
            upgradeDb.createObjectStore('OWS_tblShips', { keyPath: 'shipID' });
          }
          if (!upgradeDb.objectStoreNames.contains('OWS_tblContracts')) {
            upgradeDb.createObjectStore('OWS_tblContracts', { keyPath: 'contractID' });
          }

          if (!upgradeDb.objectStoreNames.contains('OWS_tblStockOrderList')) {
            upgradeDb.createObjectStore('OWS_tblStockOrderList', { keyPath: 'stockOrderListID' });
          }
          if (!upgradeDb.objectStoreNames.contains('OWS_tblStockInfoHeader')) {
            upgradeDb.createObjectStore('OWS_tblStockInfoHeader', { keyPath: 'shipBeginEndStockHeaderID' });
          }
          if (!upgradeDb.objectStoreNames.contains('OWS_tblStockDetailList')) {
            upgradeDb.createObjectStore('OWS_tblStockDetailList', { keyPath: 'stockDetailID' });
          }
          if (!upgradeDb.objectStoreNames.contains('OWS_tblStockHeaderLastSeq')) {
            upgradeDb.createObjectStore('OWS_tblStockHeaderLastSeq', { keyPath: 'ID' });
          }
          if (!upgradeDb.objectStoreNames.contains('OWS_tblFAQ')) {
            upgradeDb.createObjectStore('OWS_tblFAQ', { keyPath: 'ID' });
          }
          if (!upgradeDb.objectStoreNames.contains('OWS_tblClaimsCategory')) {
            upgradeDb.createObjectStore('OWS_tblClaimsCategory', { keyPath: 'claimsCategoryID' });
          }
          if (!upgradeDb.objectStoreNames.contains('OWS_tblStocksOverviewSubmitted')) {
            upgradeDb.createObjectStore('OWS_tblStocksOverviewSubmitted', { keyPath: 'shipBeginEndStockHeaderID' });
          }
          if (!upgradeDb.objectStoreNames.contains('OWS_tblStocksOverviewAccepted')) {
            upgradeDb.createObjectStore('OWS_tblStocksOverviewAccepted', { keyPath: 'shipBeginEndStockHeaderID' });
          }

          if (!upgradeDb.objectStoreNames.contains('OWS_tblReferenceList')) {
            upgradeDb.createObjectStore('OWS_tblReferenceList', { keyPath: 'ID' });
          }


          if (!upgradeDb.objectStoreNames.contains('OWS_tblStockReceivedQuantity')) {
            upgradeDb.createObjectStore('OWS_tblStockReceivedQuantity', { keyPath: 'ID' });
          }

          if (!upgradeDb.objectStoreNames.contains('OWS_tblSuggestedQuantity')) {
            upgradeDb.createObjectStore('OWS_tblSuggestedQuantity', { keyPath: 'orderID' });
          }

          if (!upgradeDb.objectStoreNames.contains('OWS_tblIFSSurveyQuestions')) {
            upgradeDb.createObjectStore('OWS_tblIFSSurveyQuestions', { keyPath: 'ifsSurveyQuestionID' });
          }

          if (!upgradeDb.objectStoreNames.contains('OWS_tblIFSSurvey')) {
            upgradeDb.createObjectStore('OWS_tblIFSSurvey', { keyPath: 'id' });
          }

          if (!upgradeDb.objectStoreNames.contains('OWS_tblShipAuditOverview')) {
            upgradeDb.createObjectStore('OWS_tblShipAuditOverview', { keyPath: 'shipAuditHeaderID' });
          }

          if (!upgradeDb.objectStoreNames.contains('OWS_tblShipAuditList')) {
            upgradeDb.createObjectStore('OWS_tblShipAuditList', { keyPath: 'id' });
          }

          if (!upgradeDb.objectStoreNames.contains('OWS_tblShipAuditDepartment')) {
            upgradeDb.createObjectStore('OWS_tblShipAuditDepartment', { keyPath: 'auditDepartmentID' });
          }

          if (!upgradeDb.objectStoreNames.contains('OWS_tblShipAuditHeader')) {
            upgradeDb.createObjectStore('OWS_tblShipAuditHeader', { keyPath: 'shipAuditHeaderID' });
          }

          if (!upgradeDb.objectStoreNames.contains('OWS_tblShipAuditDetails')) {
            upgradeDb.createObjectStore('OWS_tblShipAuditDetails', { keyPath: 'shipAuditDetailID' });
          }

          if (!upgradeDb.objectStoreNames.contains('OWS_tblShipDepartmentList')) {
            upgradeDb.createObjectStore('OWS_tblShipDepartmentList', { keyPath: 'ShipID' });
          }

          if (!upgradeDb.objectStoreNames.contains('OWS_tblInventoryDisposalOrderHeader')) {
            upgradeDb.createObjectStore('OWS_tblInventoryDisposalOrderHeader', { keyPath: 'orderInfoHeaderID' });
          }

          if (!upgradeDb.objectStoreNames.contains('OWS_tblInventoryDisposalOrderDetails')) {
            upgradeDb.createObjectStore('OWS_tblInventoryDisposalOrderDetails', { keyPath: 'orderInfoHeaderID' });
          }

          if (!upgradeDb.objectStoreNames.contains('OWS_tblInventoryDisposalOverviewOpen')) {
            upgradeDb.createObjectStore('OWS_tblInventoryDisposalOverviewOpen', { keyPath: 'orderInfoHeaderID' });
          }

          if (!upgradeDb.objectStoreNames.contains('OWS_tblInventoryDisposalOverviewSubmitted')) {
            upgradeDb.createObjectStore('OWS_tblInventoryDisposalOverviewSubmitted', { keyPath: 'orderInfoHeaderID' });
          }

          if (!upgradeDb.objectStoreNames.contains('OWS_tblInventoryDisposalOverviewDelivered')) {
            upgradeDb.createObjectStore('OWS_tblInventoryDisposalOverviewDelivered', { keyPath: 'orderInfoHeaderID' });
          }

          //  }
        },
        blocked() {
          console.log('blocked');
        },
        blocking() {
          console.log('blocking');
        },
        terminated() {
          console.log('terminated');
        }
      }).then(db => {
        this.dbInstace = db;
        return db;
      });
    }

    return this.dbPromise;
  }

  async closedDb() {
    if (this.dbInstace) {
      this.dbInstace.close();
      this.dbInstace = undefined;
      this.dbPromise = undefined;
      console.log('Closed ${this.dbName}');
    }
  }

}
